import React, { useState, useRef } from "react";
import ReactSlider from "react-slider";
import { toast } from "react-toastify";
import { Input } from "reactstrap";

const OrderRangeSlider = ({
  value,
  setValue,
  setCurrentPage,
  adminColor = "",
}) => {
  const [inputValues, setInputValues] = useState(value);
  const debounceRef = useRef(null);

  const handleInputChange = (e, index) => {
    const inputValue = e.target.value.trim();

    if (inputValue === "") {
      const newInputValues = [...inputValues];
      newInputValues[index] = 0;

      setInputValues(newInputValues);
      setValue(newInputValues);
      return;
    }

    const parsedValue = parseInt(inputValue);

    if (isNaN(parsedValue) || parsedValue < 0 || parsedValue > 10000) {
      setInputValues(value);
      return;
    }

    const newInputValues = [...inputValues];
    newInputValues[index] = parsedValue;

    if (index === 0) {
      if (newInputValues[0] > newInputValues[1]) {
        toast.error("First value should be smaller than the second value");
        setInputValues(inputValues);
        return;
      }
    } else {
      if (newInputValues[0] > newInputValues[1]) {
        newInputValues[0] = 0;
        setInputValues(newInputValues);
        setValue(newInputValues);
        return;
      }
    }

    setInputValues(newInputValues);
    setValue(newInputValues);
    setCurrentPage(0);
  };

  const handleSliderChange = (newValue) => {
    setInputValues(newValue);

    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    debounceRef.current = setTimeout(() => {
      setValue(newValue);
      setCurrentPage(0);
    }, 2000);
  };

  return (
    <div className="slider-div d-flex align-items-center gap-3">
      <Input
        type="number"
        min={0}
        max={10000}
        className="no-spin"
        value={inputValues[0]}
        onChange={(e) => handleInputChange(e, 0)}
        onBlur={(e) => handleInputChange(e, 0)}
      />
      <ReactSlider
        value={inputValues}
        onChange={handleSliderChange}
        className="horizontal-slider flex-grow-1"
        max={10000}
        min={0}
        thumbClassName="example-thumb"
        trackClassName="example-track"
        renderThumb={(props) => <div {...props}></div>}
        renderTrack={(props, state) => (
          <div
            {...props}
            style={{
              ...props.style,
              backgroundColor:
                state.index === 1
                  ? adminColor !== ""
                    ? adminColor
                    : "#0243ec"
                  : "#ddd",
            }}
          />
        )}
      />

      <Input
        type="number"
        min={0}
        max={10000}
        className="no-spin"
        value={inputValues[1]}
        onChange={(e) => handleInputChange(e, 1)}
        onBlur={(e) => handleInputChange(e, 1)}
      />
    </div>
  );
};

export default OrderRangeSlider;
